<template>
    <div class="settled-content">
        <div class="settled__row" :class="{ 'active': expandItems.includes(item) }" v-for="(item, index) in settledData"
            :key="index">
            <template v-if="$store.state.isScreenMobile">
                <div class="settled__item--header">
                    <div class="m-col-1">
                        <div class="m-row">
                            <div class="header--infor m-col-3">
                                <p class="game-name">{{ getTranslatedText(item.gameName) }}</p>
                                <p class="outcome-name">{{ getTranslatedText(item.marketName) }}</p>
                                <p class="draw-date">{{ item.drawDate }}</p>
                            </div>
                            <p :class="`status status__${item.status} m-col-4`">{{ getTranslatedText(item.status) }}</p>
                        </div>
                        <div class="m-row">
                            <div class="list-number">
                                <template v-if="item.numbers?.length > 0">
                                    <Number :customClass="'number__in-list'" v-for="(n, i) in item.numbers" :key="i"
                                        :number="n.value" :bgColor="n.color" />
                                </template>
                                <p v-else>{{ item.marketOptionName }}</p>
                            </div>
                            <p class="ref"> {{ getTranslatedText('bet ref') }} {{ item.reference }}</p>
                        </div>
                    </div>
                    <div class="m-col-2">
                        <p class="icon" @click="handleExpandItem(item)">
                            <i class="bi bi-chevron-up" v-if="expandItems.includes(item)"></i>
                            <i class="bi bi-chevron-down" v-else></i>
                        </p>
                    </div>
                </div>

                <div class="settled__item--content" v-if="expandItems.includes(item)">
                    <div class="m-row infor-number">
                        <p>{{ getTranslatedText('stake') }} {{ currencySymbol }} {{ formatPrice(+item.wager) }} <br><span v-if="item.betType == 'promo'"><strong>({{ getTranslatedText('Free bet') }})</strong></span></p>
                        <p>{{ getTranslatedText('odds') }} {{ formatPrice(+item.odds) }}</p>
                        <p class="return">
                            {{ getTranslatedText('Potential winnings') }}
                            <span>
                                {{ currencySymbol }} {{ formatPrice(item.returnValue) }}
                            </span>
                        </p>
                    </div>
                    <div class="m-row infor-number">
                        <p>{{ getTranslatedText('results') }}</p>
                        <div class="list-results">
                            
                            <Number :customClass="'number__in-list'" v-for="(n, i) in item.results" :key="i"
                                :number="n.value" :bgColor="n.color" />
                            <div class="bonus-number" v-if="item.resultsBonus?.length > 0">
                                <Number :customClass="'number__in-list'" v-for="(n, i) in item.resultsBonus" :key="i"
                                    :number="n.value" :bgColor="n.color" />
                            </div>
                        </div>
                        <p>
                            {{ getTranslatedText('winnings') }}
                            <span class="winnings-value">
                                {{ currencySymbol }} {{ formatPrice(item.winnings) }}
                            </span>
                        </p>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="settled__item--header">
                    <div class="settled__column col-1">
                        <p class="game-name">{{ getTranslatedText(item.gameName) }}</p>
                    </div>
                    <div class="settled__column col-2">
                        <p class="outcome-name">{{ getTranslatedText(item.marketName) }}</p>
                    </div>
                    <div class="settled__column col-3">
                        <p>{{ item.drawDate }}</p>
                    </div>
                    <div class="settled__column col-4">
                        <div class="list-number">
                            <template v-if="item.numbers?.length > 0">
                                <Number :customClass="'number__in-list'" v-for="(n, i) in item.numbers" :key="i"
                                    :number="n.value" :bgColor="n.color" />
                            </template>
                            <p v-else>{{ item.marketOptionName }}</p>
                        </div>
                    </div>
                    <div class="settled__column col-5">
                        <p class="ref"> {{ getTranslatedText('bet ref') }} {{ item.reference }}</p>
                    </div>
                    <div class="settled__column col-6">
                        <p :class="`status status__${item.status}`">{{ getTranslatedText(item.status) }}</p>
                        <p class="icon" @click="handleExpandItem(item)">
                            <i :class="expandItems.includes(item) ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                        </p>
                    </div>
                </div>
                <div class="settled__item--content" v-if="expandItems.includes(item)">
                    <div class="settled__column col-1">
                    </div>
                    <div class="settled__column col-2">
                        <p>{{ getTranslatedText('stake') }} </p>
                        <p class="text--bold">{{ currencySymbol }} {{ formatPrice(+item.wager) }} <br> <span v-if="item.betType == 'promo'"><strong>({{ getTranslatedText('Free bet') }})</strong></span></p>
                    </div>
                    <div class="settled__column col-3">
                        <p>{{ getTranslatedText('odds') }}</p>
                        <p class="text--bold">{{ formatPrice(+item.odds) }}</p>
                    </div>
                    <div class="settled__column col-3">
                        <p class="return">
                            {{ getTranslatedText('Potential winnings') }}
                        </p>
                        <p class="text--bold">
                            {{ currencySymbol }} {{ formatPrice(item.returnValue) }}
                        </p>
                    </div>

                    <div class="settled__column col-4">
                        <div class="list-number">
                            <p>{{ getTranslatedText('results') }}</p>
                            <div class="list-results">
                                <Number :customClass="'number__in-list'" v-for="(n, i) in item.results" :key="i"
                                    :number="n.value" :bgColor="n.color" />
                                <div class="bonus-number" v-if="item.resultsBonus?.length > 0">
                                    <Number :customClass="'number__in-list'" v-for="(n, i) in item.resultsBonus"
                                        :key="i" :number="n.value" :bgColor="n.color" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="settled__column col-6">
                        <p class="winnings">
                            {{ getTranslatedText('winnings') }}
                            <span class="winnings-value">{{ currencySymbol }} {{ formatPrice(item.winnings) }}</span>
                        </p>
                    </div>
                    <!-- <div class="settled__column col-1">
                    </div> -->
                </div>
            </template>
        </div>
    </div>
    <EmptyComponent :description="getTranslatedText('Please login to continue!')" v-if="!$store.state.isLogin" />
    <EmptyComponent :description="getTranslatedText('Data is empty')" v-else-if="settledData?.length == 0" />
    <div class="paging" v-else>
        <PagingComponent :paginator="paginator" :itemsPerPage="5" />
    </div>
</template>
<script>
import languageMixins from "@/mixins/language-mixins";
import utilsMixins from "@/mixins/function-utils";
import Number from "@/components/common/number";
import PagingComponent from "@/components/common/paging";
import EmptyComponent from '@/components/common/empty';

export default {
    mixins: [languageMixins, utilsMixins],
    components: { Number, PagingComponent, EmptyComponent },
    props: {
        bets: {
            type: Array,
        },
        currencySymbol: String,
        paginator: {}
    },
    data() {
        return {
            settledData: [],
            expandItems: [],
        }
    },
    created() {
        this.settledData = this.handleConvertData(this.bets);
    },
    watch: {
        bets: {
            handler(bets) {
                this.settledData = this.handleConvertData(bets);
            },
            deep: true,
        },
        "$store.state.gameMarket"() {
            this.settledData = this.handleConvertData(this.bets);
        },
    },
    methods: {
        handleConvertData(bets) {
            if (!bets) return [];

            const gameNumbers = this.$store.state.gameMarket || [];
            return bets.map((item) => {
                let numbers = gameNumbers.find(x => x.slug == item.game_slug)?.balls;
                let eventResults = item.event_results?.[0]
                let eventResultsBonus = item.event_results?.[1]
                let betNumbers = item.numbers?.[0]
                return {
                    id: item.id,
                    gameName: item.game_name,
                    pick: item.mo_pick,
                    marketName: item.market_name,
                    marketOptionName: item.mo_name,
                    drawDate: this.renderDateTimeText(item.draw_date),
                    numbers:
                        numbers && betNumbers
                            ? this.filterAndSortNumbers(numbers, betNumbers)
                            : [],
                    results:
                        numbers && eventResults
                            ? this.filterAndSortNumbers(numbers, eventResults)
                            : [],
                    resultsBonus:
                        numbers && eventResultsBonus
                            ? this.filterAndSortNumbers(numbers, eventResultsBonus)
                            : [],
                    odds: item.odds,
                    wager: item.wager,
                    returnValue: item.wager * item.odds,
                    status: item.bet_status,
                    reference: item.reference,
                    winnings: item.winnings,
                    betType: item.bet_type,
                }
            })
        },
        handleExpandItem(item) {
            let index = this.expandItems.findIndex(x => x.id === item.id);
            if (index > -1) {
                this.expandItems.splice(index, 1)
            } else {
                this.expandItems.push(item);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/public/scss/components/my-bets/settled.scss";
</style>